import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceYogaRoutine = lazyWithPreload(
  () => import('./FaceYogaRoutine'),
)
